 const content = {
    serverUrl:process.env.REACT_APP_API_URL,
    appVersions:process.env.REACT_APP_VERSION
};
export default content